import PressThumbLogo from "../../../../src/images/services/pressthumb.svg";
import * as React from 'react';
export default {
  PressThumbLogo,
  React
};